/* Képkeret rétegről rétegre: görgetésre szétnyíló és összecsúszó 3D nézet (<kk3d-layers>).
 * A 3D motor (kk-keret-3d.js, layers mód) csak a szekció közelében töltődik be.
 * Főoldal: minta, keretszín, méret és extrák (díszcsomagolás, LED, NFC) választhatók.
 * Termékoldal: a kiválasztott variánst (szín, méret, tájolás) és a Teeinblue-ban kért extrákat követi;
 * a grafika a vásárló Teeinblue előnézete, ha olvasható, különben a beállított minta. */
(() => {
  if (customElements.get('kk3d-layers')) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = !!(navigator.connection && navigator.connection.saveData);
  const engines = new Map();
  const engine = url => { if (!engines.has(url)) engines.set(url, import(url).catch(e => { engines.delete(url); throw e; })); return engines.get(url); };
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const seg = (p, a, b) => clamp((p - a) / (b - a));
  const ease = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  const deg = d => d * Math.PI / 180;
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[c]));

  const COLOR_RULES = [[/fehér/i, 'white'], [/fekete/i, 'black'], [/nyír/i, 'birch'], [/tölgy/i, 'oak'], [/arany/i, 'gold'], [/ezüst/i, 'silver']];
  const COLOR_NAMES = { white:'Fehér', black:'Fekete', birch:'Nyír hatású', oak:'Tölgy hatású', gold:'Arany', silver:'Ezüst' };
  const NO_LED = ['gold', 'silver'];   // az arany és ezüst keretbe nem ragasztható LED szalag
  const SIZE_NAMES = { '13x18':'13×18 cm', '21x30':'A4', '30x40':'30×40 cm' };
  function parseVariant(opts){
    let color = null, size = null, orient = null;
    for (const raw of opts || []){
      const v = String(raw || '');
      if (!color && /képkeret/i.test(v)) for (const [re, k] of COLOR_RULES) if (re.test(v)){ color = k; break; }
      const m = [...v.matchAll(/(\d{2})\s*[x×]\s*(\d{2})/gi)].pop();
      if (m){ const a = +m[1], b = +m[2], k = `${Math.min(a, b)}x${Math.max(a, b)}`; if (SIZE_NAMES[k]){ size = k; orient = a > b ? 'landscape' : 'portrait'; } }
    }
    return color && size ? { color, size, orient } : null;
  }
  /* Teeinblue extrák: a mező címéből ismerjük fel, és az „Igen” válasz számít */
  const EXTRA_RULES = { led:/LED/i, nfc:/NFC/i, wrap:/díszcsomagol/i };
  const WRAP_COLORS = [['rosegold', /rose\s*gold/i], ['gold', /arany/i], ['silver', /ezüst/i], ['purple', /lila/i], ['hearts', /sz[ií]v/i]];
  const PAPER_RIBBON = { gold:'bordo', silver:'blue', rosegold:'bordo', purple:'yellow', hearts:'bordo' };   // a papír alapértelmezett szalagja
  /* a Teeinblue előnézet (a vásárló terve): arány és egy olcsó ujjlenyomat, amiből látszik, ha a terv megváltozott */
  function teeArt(){
    const all = [...document.querySelectorAll('svg.tee-mockup-artwork')];
    const sv = all.find(x => x.getBoundingClientRect().width > 0) || all[0];
    if (!sv) return null;
    const vb = (sv.getAttribute('viewBox') || '').split(/[\s,]+/).map(Number);
    const w = vb[2] || sv.clientWidth, h = vb[3] || sv.clientHeight;
    if (!w || !h) return null;
    const hrefs = [...sv.querySelectorAll('image')].map(i => i.getAttribute('href') || i.getAttribute('xlink:href') || '').filter(u => !u.startsWith('blob:'));
    return { aspect: w / h, sig: [sv.getAttribute('viewBox'), ...hrefs, sv.textContent].join('|') };
  }
  const orientOf = a => a > 1.02 ? 'landscape' : a < .98 ? 'portrait' : null;
  function teeExtras(){
    const out = {}; let found = false;
    document.querySelectorAll('.tee-field').forEach(f => {
      const h = f.querySelector('.tee-field__heading'); if (!h) return;
      const labelOf = i => { const l = f.querySelector(`label[for="${i.id}"]`) || i.closest('label') || i.parentElement; return l ? l.textContent.trim() : ''; };
      const inputs = [...f.querySelectorAll('input')], yesNo = inputs.some(i => /^igen/i.test(labelOf(i)));
      for (const [k, re] of Object.entries(EXTRA_RULES)) if (re.test(h.textContent)){
        if (yesNo){ found = true; out[k] = !!out[k] || inputs.some(i => i.checked && /^igen/i.test(labelOf(i))); }
        else if (k === 'wrap'){   // a csomagolópapír színe (külön mező)
          const sel = inputs.find(i => i.checked), txt = sel ? labelOf(sel) : '';
          for (const [c, r2] of WRAP_COLORS) if (r2.test(txt)){ out.wrapColor = c; break; }
        }
      }
    });
    return found ? out : null;
  }

  class KeretLayers extends HTMLElement {
    connectedCallback(){
      if (this._init) return; this._init = true;
      try { this.cfg = JSON.parse(this.querySelector('script[data-kkl-config]').textContent); } catch { this.cfg = {}; }
      this.sec = this.closest('[data-kkl]') || this;
      this.scroller = this.sec.querySelector('[data-kkl-scroller]');
      this.labelsEl = this.querySelector('[data-kkl-labels]');
      this.capStep = this.querySelector('[data-kkl-step]'); this.capTxt = this.querySelector('[data-kkl-cap]');
      this.rail = [...this.querySelectorAll('[data-kkl-rail] b')];
      this.hint = this.querySelector('[data-kkl-hint]');
      this.nameEl = this.sec.querySelector('[data-kkl-name]');
      // keskeny kijelzőn a rétegek csak számot kapnak, a kiemelt réteg neve és leírása itt jelenik meg
      this.focusEl = document.createElement('div'); this.focusEl.className = 'kkl__focus'; this.focusEl.setAttribute('aria-hidden', 'true');
      (this.labelsEl ? this.labelsEl.after(this.focusEl) : this.appendChild(this.focusEl));
      const d = this.dataset;
      this.st = { g:0, color:d.color || 'oak', size:d.size || '21x30', orient:'auto', extras:{ wrap:d.wrap === 'true', led:false, nfc:false, ledColor:'warm', wrapColor:d.wrapColor || 'rosegold' } };   // J-91: becsomagolva indulhat
      this.product = d.product === 'true';
      this.p = reduce ? .5 : 0;
      if (reduce) this.sec.classList.add('is-static');
      // választó
      this.sec.addEventListener('click', e => {
        const b = e.target.closest('[data-kkl-opt]'); if (!b || b.disabled || !this.sec.contains(b)) return;
        const o = b.dataset.kklOpt, v = b.dataset.val;
        if (o === 'extra'){ this.st.extras[v] = !this.st.extras[v]; this.userExtras = true; }
        else if (o === 'wrapColor'){ this.st.extras.wrapColor = v; this.st.extras.ribbon = null; }
        else if (o === 'ribbon') this.st.extras.ribbon = v;
        else if (o === 'g') this.st.g = +v;
        else this.st[o] = v;
        this.sync();
        // bekapcsolt extránál rövid bemutató: a nézet magától odaugrik, ahol az új réteg látszik
        const p = this.ctl ? this.push() : (this.pending = true, this.mount());
        if (o === 'extra' && this.st.extras[v]) Promise.resolve(p).then(() => this.peek(v));
        else if (o === 'wrapColor' || o === 'ribbon') Promise.resolve(p).then(() => this.peek('paper'));   // csomagolópapír vagy szalag: a becsomagolt ajándék elölről
      });
      if (this.product) this.initProduct();
      this.sync();
      // betöltés a szekció közelében
      const go = () => this.mount();
      if (saveData){ const b = this.querySelector('[data-kkl-load]'); if (b){ b.hidden = false; b.addEventListener('click', go); } }
      else { this.io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)){ this.io.disconnect(); go(); } }, { rootMargin:'1500px 0px' }); this.io.observe(this.scroller || this); }
      this.onScroll = () => {
        if (this.pk && performance.now() > this.pk.ignoreUntil) this.pk = null;   // a látogató görget: a bemutató véget ér
        if (!this.raf) this.raf = requestAnimationFrame(() => { this.raf = 0; this.update(); });
      };
      if (!reduce){ addEventListener('scroll', this.onScroll, { passive:true }); }
      addEventListener('resize', this.onScroll);
      this.ro = new ResizeObserver(this.onScroll); this.ro.observe(this);
    }
    disconnectedCallback(){
      this.io?.disconnect(); this.ro?.disconnect(); removeEventListener('scroll', this.onScroll); removeEventListener('resize', this.onScroll);
      clearInterval(this.timer); document.removeEventListener('change', this.onChange, true); document.removeEventListener('variant:changed', this.onVar);
      this.ctl?.destroy(); this.ctl = null; this._init = false;
    }

    /* ---------- termékoldal: variáns és extrák követése ---------- */
    initProduct(){
      this.onVar = () => this.refreshProduct();
      document.addEventListener('variant:changed', this.onVar);
      document.addEventListener('change', this.onChange = () => setTimeout(this.onVar, 80), true);
      this.timer = setInterval(() => { if (!document.hidden) this.refreshProduct(); }, 1000);
      this.refreshProduct(true);
    }
    variantId(){
      const fromUrl = new URLSearchParams(location.search).get('variant');
      const inp = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
      return String(fromUrl || (inp && inp.value) || this.cfg.selected || '');
    }
    refreshProduct(first){
      let changed = false;
      const id = this.variantId();
      if (id !== this.lastId){
        this.lastId = id;
        const v = parseVariant((this.cfg.variants || {})[id]);
        this.sec.hidden = !v;
        if (v){ this.st.color = v.color; this.st.size = v.size; this.st.orient = v.orient; changed = true; this.imgDirty = true; }
      }
      // a tájolás a vásárló tervét követi; ha a terv változik (és két ütemen át változatlan), újra beolvassuk
      const art = this.cfg.tib ? teeArt() : null;
      if (art){
        const o = orientOf(art.aspect);
        if (o && o !== this.artOrient){ this.artOrient = o; changed = true; }
        if (art.sig !== this.artSig){
          if (this.artPending === art.sig){ this.artSig = art.sig; this.artPending = null; this.imgDirty = true; changed = true; }
          else this.artPending = art.sig;
        }
      }
      const ex = teeExtras();
      if (ex){
        const key = JSON.stringify(ex);
        if (key !== this.exKey){ this.exKey = key; Object.assign(this.st.extras, ex); this.userExtras = false; changed = true; }
      }
      if (changed && !first){ this.sync(); this.push(); }
    }

    /* ---------- választó állapot ---------- */
    sync(){
      const st = this.st;
      this.sec.querySelectorAll('[data-kkl-opt]').forEach(b => {
        const o = b.dataset.kklOpt, v = b.dataset.val;
        const paper = st.extras.wrapColor, ribbon = st.extras.ribbon || PAPER_RIBBON[paper];
        const on = o === 'extra' ? !!st.extras[v] : o === 'g' ? +v === st.g : o === 'wrapColor' ? paper === v : o === 'ribbon' ? ribbon === v : st[o] === v;
        b.setAttribute('aria-pressed', String(on));
        if (o === 'ribbon') b.hidden = !(b.dataset.for || '').split(' ').includes(paper);
        if (o === 'extra' && v === 'led') b.hidden = NO_LED.includes(st.color);
      });
      this.sec.querySelectorAll('[data-kkl-wrapopts], [data-kkl-wrapnote]').forEach(g => { g.hidden = !st.extras.wrap; });
      if (this.nameEl) this.nameEl.textContent = `${COLOR_NAMES[st.color] || ''} keret, ${SIZE_NAMES[st.size] || ''}`;
    }
    graphic(){
      const G = this.cfg.graphics || [], g = G[this.st.g];
      if (g) return g.port || g.land || null;
      return this.cfg.image || null;
    }
    async productGraphic(){
      if (this.cfg.tib){
        try { const { captureTeeinblue } = await engine(this.dataset.module); const c = await captureTeeinblue(); if (c) return c; }
        catch (e){ console.warn('[KK rétegek] Teeinblue előnézet nem olvasható:', e); }
      }
      return this.cfg.image || null;
    }
    params(){
      const st = this.st, p = { size:st.size, color:st.color, mode:'wall', extras:{ ...st.extras } };
      if (NO_LED.includes(st.color)) p.extras.led = false;
      // termékoldalon: a vásárló terve, aztán a variáns nevében jelölt fekvő méret (pl. 30x21), aztán a termék saját grafikája, végül a variáns neve
      p.orient = !this.product ? 'auto' : this.artOrient || (st.orient === 'landscape' ? 'landscape' : this.cfg.imgSrc === 'product' ? 'auto' : st.orient) || 'auto';
      return p;
    }
    async push(){
      if (!this.ctl){ this.pending = true; return this.mountP; }
      const p = this.params();
      if (this.product){ if (this.imgDirty){ this.imgDirty = false; p.image = await this.productGraphic(); } }
      else { const img = this.graphic(); if (img !== this.lastImg){ p.image = img; this.lastImg = img; } }
      this.classList.add('is-loading');
      this.queue = (this.queue || Promise.resolve()).then(() => this.ctl.set(p)).then(() => { this.makeLabels(); this.update(); })
        .catch(e => console.warn('[KK rétegek]', e)).finally(() => this.classList.remove('is-loading'));
      return this.queue;
    }

    /* ---------- motor ---------- */
    mount(){ return this.mountP ||= this.doMount(); }
    async doMount(){
      if (this.ctl) return; this.mounting = true;
      this.classList.add('is-loading');
      try {
        const { mountKeret3D } = await engine(this.dataset.module);
        const d = this.dataset, p = this.params();
        let image;
        if (this.product){ image = await this.productGraphic(); this.imgDirty = false; } else { image = this.graphic(); this.lastImg = image; }
        this.ctl = await mountKeret3D(this.querySelector('[data-kkl-stage]') || this, {
          ...p, image, view:'threeq', autoRotate:false, zoom:false, interactive:false, layers:true,
          textures:{ oak:d.texOak, birch:d.texBirch, black:d.texBlack, brown:d.texBrown }, logos:{ light:d.logoLight, dark:d.logoDark },
          maxPixelRatio:1.5, onError: e => console.warn('[KK rétegek]', e.message),
        });
        this.classList.add('is-ready');
        this.makeLabels(); this.update();
        if (this.pending){ this.pending = false; await this.push(); }
      } catch (e){
        console.warn('[KK rétegek] A 3D nézet nem töltődött be:', e);
        this.classList.add('is-failed'); this.mountP = null;
      } finally { this.classList.remove('is-loading'); this.mounting = false; }
    }

    /* ---------- feliratok ---------- */
    labelFor(key, m){
      const L = this.cfg.labels || {};
      const k = key === 'outer' && m.slim ? 'outer_slim' : key === 'back' ? (m.back === 'black' ? 'back_black' : 'back_natural') : key === 'wrapF' ? 'wrap' : key;
      return L[k] || L[key] || { t:key, d:'' };
    }
    makeLabels(){
      if (!this.ctl || !this.labelsEl) return;
      const m = this.ctl.metrics(), keys = m.layers.filter(k => k !== 'wrapB');   // a csomagolás hátsó fele nem kap feliratot
      this.metricsCache = m;
      this.labelsEl.innerHTML = '';
      this.labs = {};
      let n = 0;
      for (const k of keys){
        const L = this.labelFor(k, m), el = document.createElement('div');
        const num = k === 'wrapF' ? '' : String(++n);
        el.className = 'kkl-lab' + (k === 'wrapF' ? ' kkl-lab--wrap' : '');
        el.innerHTML = `<div class="kkl-lab__card">${num ? `<span class="kkl-lab__n">${num}</span>` : '<span class="kkl-lab__n kkl-lab__n--gift" aria-hidden="true"><svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-2-4-6-4-6-1.5S12 7 12 7zm0 0c2-4 6-4 6-1.5S12 7 12 7z"/></svg></span>'}<span class="kkl-lab__t">${esc(L.t)}</span>${L.d ? `<span class="kkl-lab__d">${esc(L.d)}</span>` : ''}</div><span class="kkl-lab__stem"></span><span class="kkl-lab__dot"></span>`;
        this.labelsEl.appendChild(el); this.labs[k] = { el, i:n - 1, t:L.t, d:L.d, num };
      }
      this.layerCount = n;
    }

    /* ---------- bemutató egy extra bekapcsolásakor ---------- */
    peek(kind){
      if (!this.ctl || reduce) return;
      const target = kind === 'paper' ? .03 : .5, from = this.p || 0, t0 = performance.now(), A = 900, H = 2200, B = 800;
      const r = this.getBoundingClientRect();
      const quietUntil = t0 + A + H + B + 200;   // azonosító: egy újabb bemutató felülírja
      let ignoreUntil = t0 + 120;
      if (r.top > innerHeight * .25 || r.bottom < innerHeight * .6){   // ha a színpad nem látszik, odagörgetünk
        const st = this.scroller.getBoundingClientRect().top + scrollY - (parseFloat(getComputedStyle(this).top) || 0);
        scrollTo({ top: st + 2, behavior:'smooth' }); ignoreUntil = t0 + 1200;
      }
      this.pk = { kind, quietUntil, ignoreUntil, val:from };
      const step = now => {
        if (!this.pk || this.pk.quietUntil !== quietUntil) return;
        const e = now - t0, real = this.progress(true);
        let v;
        if (e < A) v = from + (target - from) * ease(e / A);
        else if (e < A + H) v = target;
        else if (e < A + H + B) v = target + (real - target) * ease((e - A - H) / B);
        else { this.pk = null; this.update(); return; }
        this.pk.val = v; this.update(); requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }

    /* ---------- görgetés ---------- */
    progress(real){
      if (!real && this.pk) return this.pk.val;
      if (reduce || !this.scroller) return .5;
      const r = this.scroller.getBoundingClientRect(), st = this.querySelector('[data-kkl-stage]') || this;
      const top = parseFloat(getComputedStyle(this).top) || 0, total = r.height - st.clientHeight;
      return total > 0 ? clamp((top - r.top) / total) : .5;
    }
    update(){
      const p = this.progress(); this.p = p;
      const c = this.cfg.captions || [];
      const k = p < .10 ? 0 : p < .36 ? 1 : p < .66 ? 2 : 3;
      const m = this.ctl ? this.ctl.metrics() : null, n = m ? m.layers.length : 6, wrapOn = !!(m && m.wrap);
      const nLayers = m ? m.layers.filter(x => x !== 'wrapF' && x !== 'wrapB').length : 6;
      if (this.capStep) this.capStep.textContent = `${k + 1} / 4`;
      if (this.capTxt){ let txt = (wrapOn && k === 3 ? c[4] : wrapOn && k === 0 ? c[5] || c[0] : c[k]) || ''; this.capTxt.textContent = txt.replace('{n}', nLayers); }
      const ph = [[0, .10], [.10, .36], [.36, .66], [.66, 1]];
      this.rail.forEach((b, i) => { b.style.height = (seg(p, ph[i][0], ph[i][1]) * 100) + '%'; });
      if (this.hint) this.hint.style.opacity = p < .04 ? 1 : 0;
      if (!this.ctl) return;

      const t = reduce ? 1 : ease(seg(p, .10, .36)) * (1 - ease(seg(p, .66, .86)));
      const turn = reduce ? 1 : ease(seg(p, 0, .3)) * (1 - ease(seg(p, .80, .95)));
      const aspect = m.aspect || 1, az = deg(32 + 40 * turn), el = deg(12 + 6 * turn);
      // a szétnyitott csomag hossza a színpad arányához és a rétegek számához igazodik
      const total = m.span * clamp(1.1 * aspect, .7, 2) * Math.sqrt(Math.max(1, n) / 6);
      const gapK = total / m.span / Math.max(1, n - 1), stackLen = total * t;
      const tanV = Math.tan(deg(m.fov / 2));
      const vert = m.orient === 'landscape' ? m.W : m.H, fill = .64 - .12 * t;
      const distV = (vert + stackLen * .28) / (fill * 2 * tanV);
      const distH = 1.15 * (stackLen * Math.sin(az) + m.span * .6) / (2 * tanV * aspect);
      this.ctl.setExplode({ t, gapK });
      // mobilon a becslés kevés lehet: a pontos illesztés garantálja, hogy a teljes keret beférjen a képbe
      const fitD = this.ctl.fitOrbit ? this.ctl.fitOrbit({ az, el, ty:-m.span * .02 }) : 0;
      this.ctl.setOrbit({ az, el, dist:Math.max(distV, distH, fitD), ty:-m.span * .02 });
      // a megállásnál a rétegek sorban kiemelődnek
      const nn = this.layerCount || nLayers;
      let active = !reduce && p >= .36 && p < .66 ? Math.min(nn - 1, Math.floor(seg(p, .38, .64) * nn)) : -1;
      if (this.pk && this.labs && this.labs[this.pk.kind]) active = this.labs[this.pk.kind].i;
      this.placeLabels(t, active, !!(this.pk && this.pk.kind === 'wrap'));
    }
    placeLabels(t, active = -1, giftActive = false){
      if (!this.labs) return;
      const anchors = this.ctl.layerAnchors(), W = this.clientWidth, dots = W < 560, base = dots ? 10 : 22;
      this.labelsEl.classList.toggle('is-dots', dots);
      // a csomagolás felirata összecsukva (elején és végén) felül, szétnyitva a rétegek sorában alul látszik
      const showL = clamp((t - .7) / .25), showW = Math.max(showL, clamp((.3 - t) / .2));
      const items = [];
      for (const a of anchors){ const L = this.labs[a.key]; if (!L) continue; const gift = a.key === 'wrapF'; items.push({ a, L, gift, below: gift ? t > .5 : L.i % 2 === 1 }); }
      // egy sorba igazítva: felül a páratlan, alul a páros rétegek felirata
      const tops = items.filter(i => !i.below).map(i => i.a.top[1]), bots = items.filter(i => i.below).map(i => i.a.bottom[1]);
      const rowTop = tops.length ? Math.min(...tops) : 0, rowBot = bots.length ? Math.max(...bots) : 0;
      // ha szűk a hely, csak a rétegek neve látszik
      let minGap = Infinity;
      for (const r of [false, true]){ const v = items.filter(i => i.below === r && !i.gift).map(i => i.a.top[0]).sort((x, y) => x - y); for (let i = 1; i < v.length; i++) minGap = Math.min(minGap, v[i] - v[i - 1]); }
      this.labelsEl.classList.toggle('is-compact', minGap < 230);
      const seen = new Set();
      // a kiemelt réteg címkéje a helyén nyílik ki (cím és leírás), összecsukott csomagnál a csomag címkéje
      const giftOn = giftActive || t < .3;
      for (const { a, L, gift, below } of items){
        seen.add(a.key);
        const [x, y] = below ? a.bottom : a.top;
        const stem = base + (below ? rowBot - y : y - rowTop);
        L.el.classList.toggle('kkl-lab--below', below);
        L.el.querySelector('.kkl-lab__stem').style.height = stem.toFixed(1) + 'px';
        const on = gift ? giftOn : L.i === active;
        L.el.classList.toggle('is-active', on);
        // a kinyitott kártya ne lógjon ki a színpadról: csak a kártya csúszik be, a pont a rétegen marad
        let dx = 0;
        if (on){ const hw = L.el.querySelector('.kkl-lab__card').offsetWidth / 2 + 8; dx = Math.min(W - hw, Math.max(hw, x)) - x; }
        L.el.style.setProperty('--dx', dx.toFixed(1) + 'px');
        L.el.style.transform = `translate(${x.toFixed(1)}px, ${y.toFixed(1)}px) translate(-50%, ${below ? '0' : '-100%'})`;
        L.el.style.opacity = gift ? showW : showL;
      }
      this.focusEl.classList.remove('is-on');   // a lenti kártya helyett a címke a helyén nyílik ki
      for (const [k, L] of Object.entries(this.labs)) if (!seen.has(k)) L.el.style.opacity = 0;
    }
  }
  customElements.define('kk3d-layers', KeretLayers);
})();
